import { VGL_ERROR_CODE } from '@/services/errorHandler/errorCodes';
import type {
  VGLErrorMessages,
  VGLUserErrorMessages,
} from '@/services/errorHandler/types';

export const VglErrorMessages: VGLErrorMessages = {
  [VGL_ERROR_CODE.GENERAL_GENERIC]: 'Something went wrong',
  [VGL_ERROR_CODE.GENERAL_ERROR_HANDLER_CONSTRUCTOR]: 'Missing error services',
  [VGL_ERROR_CODE.GENERAL_UNHANDLED_START_CALCULATION_ERROR]:
    'Error while executing form validation',
  [VGL_ERROR_CODE.GENERAL_404]: 'Page not found - 404 triggered',
  [VGL_ERROR_CODE.GENERAL_SETUP]: 'App setup failed',
  [VGL_ERROR_CODE.GENERAL_UNEXPECTED_EMPTY_RESPONSE]:
    'Unexpected empty jSend response',

  [VGL_ERROR_CODE.PRINT_NO_TEMPLATE_SELECTED]:
    'No template selected for deletion',
  [VGL_ERROR_CODE.PRINT_SUBMIT]: 'Print onSubmit handler failed',
  [VGL_ERROR_CODE.PRINT_NO_DEFAULT_TEMPLATE_LOADED]:
    'Print default template has not been loaded yet',

  [VGL_ERROR_CODE.BROKER_LOADING_FAILED]: 'Failed to load broker',
  [VGL_ERROR_CODE.BROKER_LOADING_RIGHTS_FAILED]: 'Failed to load rights',
  [VGL_ERROR_CODE.BROKER_LOADING_SETTINGS_FAILED]: 'Failed to load settings',
  [VGL_ERROR_CODE.BROKER_SAVING_SETTINGS_FAILED]: 'Failed to save settings',
  [VGL_ERROR_CODE.BROKER_ID_NOT_SET]: 'Try to receive ID but data not loaded',
  [VGL_ERROR_CODE.BROKER_SOFTFAIR_TRANSMIT_FAILED]:
    'Failed to transmit broker id to Softfair',

  [VGL_ERROR_CODE.CHOICES_SIMPLE_LOADING_FAILED]:
    'Failed to load simple choices',
  [VGL_ERROR_CODE.CHOICES_API_LOADING_FAILED]: 'Failed to load api choices',
  [VGL_ERROR_CODE.CHOICES_API_WRONG_API_RESPONSE]: 'Wrong api choices response',
  [VGL_ERROR_CODE.CHOICES_API_MISSING_ENDPOINT]:
    'API choices endpoint is missing',
  [VGL_ERROR_CODE.CHOICES_SIMPLE_UNREGISTERED]:
    'Choice was not registered in sparten config',

  [VGL_ERROR_CODE.CLIENTS_LOADING_FAILED]: 'Failed to load client by id',
  [VGL_ERROR_CODE.CLIENTS_SAVING_FAILED]: 'Failed to save client',
  [VGL_ERROR_CODE.CLIENTS_MISSING_VN]: 'Versicherungsnehmer does not exist',
  [VGL_ERROR_CODE.CLIENTS_MISSING_VP]: 'Versicherte Person does not exist',
  [VGL_ERROR_CODE.CLIENTS_MISSING_ZP]: 'Zahlperson does not exist',
  [VGL_ERROR_CODE.CLIENTS_MISSING_MP]: 'Mitversicherter Partner does not exist',
  [VGL_ERROR_CODE.CLIENTS_GET_BY_REF_ID_FAILED]:
    'Could not find client by refId',
  [VGL_ERROR_CODE.CLIENTS_MISSING_ENTITY]: 'Could not find client entity',

  [VGL_ERROR_CODE.COMPANIES_LOADING_FAILED]: 'Failed to load companies',
  [VGL_ERROR_CODE.COMPANIES_SPECIAL_LOADING_FAILED]:
    'Failed to load special companies',

  [VGL_ERROR_CODE.FEATURES_LOADING_FAILED]: 'Failed to load features',
  [VGL_ERROR_CODE.FEATURES_TARIFF_LOADING_FAILED]:
    'Failed to load tariff features',
  [VGL_ERROR_CODE.FEATURES_GET_COMPONENT_FAILED]:
    'Failed to get component for type',
  [VGL_ERROR_CODE.FEATURES_MISSING]: 'Trying to access non-existing feature',

  [VGL_ERROR_CODE.GLOBAL_LOADING_FAILED]: 'Failed to load sparten status',
  [VGL_ERROR_CODE.GLOBAL_INITIALIZATION_FAILED]: 'Failed to initialize sparte',
  [VGL_ERROR_CODE.GLOBAL_NO_SPARTE]: 'No sparte was set',

  [VGL_ERROR_CODE.MAIL_TEMPLATES_LOADING_FAILED]:
    'Failed to load mail templates',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_LOADING_DEFAULT_FAILED]:
    'Failed to load mail default template',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_LOADING_PLACEHOLDERS_FAILED]:
    'Failed to load mail placeholders',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_GENERATE_PREVIEW_FAILED]:
    'Failed to generate mail preview',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_STORING_FAILED]:
    'Failed to store mail template',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_UPDATING_FAILED]:
    'Failed to update mail template',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_DELETING_FAILED]:
    'Failed to delete mail template',
  [VGL_ERROR_CODE.MAIL_MISSING_EDITOR_REF]:
    'Failed to auto insert placeholder due to missing DsEditor ref',

  [VGL_ERROR_CODE.PROFILE_LOADING_FAILED]: 'Failed to load profiles',
  [VGL_ERROR_CODE.PROFILE_STORING_FAILED]: 'Failed to store profile',
  [VGL_ERROR_CODE.PROFILE_UPDATING_FAILED]: 'Failed to update profile',
  [VGL_ERROR_CODE.PROFILE_DELETING_FAILED]: 'Failed to delete profile',
  [VGL_ERROR_CODE.PROFILE_LOADING_SELECTED_FAILED]:
    'Failed to load selected profile',
  [VGL_ERROR_CODE.PROFILE_NOT_FOUND]: 'Profile not found',

  [VGL_ERROR_CODE.QUOTE_LOADING_FAILED]: 'Failed to load quote',
  [VGL_ERROR_CODE.QUOTE_STORING_FAILED]: 'Failed to store quote',
  [VGL_ERROR_CODE.QUOTE_TRANSFORMATION_FAILED]:
    'Failed to transform legacy offer',
  [VGL_ERROR_CODE.QUOTE_GENERATE_INVENTORY_CONTRACT_FAILED]:
    'Failed to generate inventory contract',
  [VGL_ERROR_CODE.QUOTE_WEBREPORT_LOADING_FAILED]: 'Failed to load webreport',
  [VGL_ERROR_CODE.QUOTE_INVALID_INPUT_DATA]:
    'Received invalid quote input data',
  [VGL_ERROR_CODE.QUOTE_INVENTORY_CONTRACT_LOADING_FAILED]:
    'Failed to load inventory contract',
  [VGL_ERROR_CODE.QUOTE_WEBREPORT_NOT_FOUND]: 'Webreport not found - 404',

  [VGL_ERROR_CODE.TARIFFS_LOADING_FAILED]: 'Failed to load tariffs',
  [VGL_ERROR_CODE.TARIFFS_LOADING_CHUNK_FAILED]: 'Failed to load tariff chunk',
  [VGL_ERROR_CODE.TARIFFS_CONTRACT_TARIFF_NOT_FOUND]:
    'No contract tariff loaded',
  [VGL_ERROR_CODE.TARIFFS_LOADING_SPECIAL_FAILED]: 'Failed to load tariffs',

  [VGL_ERROR_CODE.VALIDATION_MISSING_LOCALE]:
    'Failed to load validation locale',

  [VGL_ERROR_CODE.ROUTER_INVALID_STEPS]: 'Sparte contains invalid steps',
  [VGL_ERROR_CODE.ROUTER_LOADING_ROUTE_FAILED]:
    'Error during pushing new route',

  [VGL_ERROR_CODE.API_AXIOS_ERROR]: 'An Axios Error occurred',

  [VGL_ERROR_CODE.UTIL_VALIDATE_ALL_FAILED]:
    'An Error occurred while validating all func',
  [VGL_ERROR_CODE.UTIL_VALIDATE_AT_FAILED]:
    'An Error occurred while validating at',
  [VGL_ERROR_CODE.UTIL_CREATE_VALIDATOR_FAILED]:
    'Could not create client validator',
  [VGL_ERROR_CODE.UTIL_CREATE_VALIDATE_STATE_FAILED]:
    'Could not create validate state',

  [VGL_ERROR_CODE.DISTRIBUTION_REQUEST_INVALID_TARIFF]:
    'Requested tariff was not in active tariffs',
  [VGL_ERROR_CODE.DISTRIBUTION_LOADING_FAILED]:
    'Failed to load distribution settings',
  [VGL_ERROR_CODE.DISTRIBUTION_NO_VALID_TARIFF_RECOMMENDED]:
    'No valid tariff set as recommendation',
  [VGL_ERROR_CODE.DISTRIBUTION_SAVING_FAILED]:
    'Failed to save distribution settings',
  [VGL_ERROR_CODE.DISTRIBUTION_SELECTED_POOL_NOT_FOUND]:
    'Selected pool not found',
  [VGL_ERROR_CODE.DISTRIBUTION_POOL_CALLBACK_FAILED]: 'Pool Callback failed',

  [VGL_ERROR_CODE.BANK_LOADING_FAILED]:
    'Could not load bank information by iban',
  [VGL_ERROR_CODE.BANK_VALIDATION_LOADING_FAILED]:
    'Could not load validation information for iban',

  [VGL_ERROR_CODE.FILES_LOADING_FAILED]: 'Could not load files',

  [VGL_ERROR_CODE.UTIL_FORM_MISSING_CLIENT_STORE]:
    'Form is missing client store as v-model',
  [VGL_ERROR_CODE.UTIL_FORM_MISSING_INPUT_STORE]:
    'Form is missing input store as v-model',
  [VGL_ERROR_CODE.UTIL_FORM_MISSING_CONTRACT_STORE]:
    'Form is missing contract store as v-model',
  [VGL_ERROR_CODE.UTIL_FORM_MISSING_CLIENT_ROLE]:
    'Client field in form is missing a role!',

  [VGL_ERROR_CODE.CONTRACT_PAGE_PROPERTY_UNKNOWN_PREVIOUS_DAMAGE]:
    'Unknown previous damage value',
  [VGL_ERROR_CODE.CONTRACT_PAGE_PROPERTY_UNKNOWN_PREVIOUS_INSURANCE]:
    'Unknown previous insurance value',

  [VGL_ERROR_CODE.PREVIOUS_INSURANCE_CAN_CANCEL_CHECK_FAILED]:
    'Failed to load can cancel check',
  [VGL_ERROR_CODE.PREVIOUS_INSURANCE_LOADING_PRELIMINARY_CONTRACT_FAILED]:
    'Failed to load can preliminary contract',

  [VGL_ERROR_CODE.CONTRACT_GENERATE_FAILED]: 'Generate contract failed',
  [VGL_ERROR_CODE.CONTRACT_BUILD_DATA_FAILED]: 'Building contract Data failed',
  [VGL_ERROR_CODE.CONTRACT_VN_HAS_NO_ID]:
    'Versicherungsnehmer does not hav an valid id',
  [VGL_ERROR_CODE.CONTRACT_NO_RESPONSE_DATA]:
    'There is no response data on the completion page',

  [VGL_ERROR_CODE.TRACKING_INSTALLATION_FAILED]:
    'Installation of tracking code failed',
  [VGL_ERROR_CODE.TRACKING_NOT_INITIALIZED]:
    'Tracking has not been initialized',

  [VGL_ERROR_CODE.LOGGER_PARSING_FAILED]: 'Failed to parse log message',

  [VGL_ERROR_CODE.COMPANY_QUESTION_MISSING_VALIDATION_DEFINITION]:
    'Missing validation definition',
  [VGL_ERROR_CODE.COMPANY_QUESTION_MISSING_FRONTEND_KEY_FOR_SPARTE]:
    'Missing frontendKey for given sparte',
  [VGL_ERROR_CODE.COMPANY_QUESTION_FAILED_TO_LOAD_QUESTIONS]:
    'Failed to load company questions',
  [VGL_ERROR_CODE.COMPANY_QUESTION_ACCESSING_INVALID_ID]:
    'Trying to access question which has not been loaded yet',

  [VGL_ERROR_CODE.EVB_LOADING_FAILED]: 'Failed loading eVB control information',
  [VGL_ERROR_CODE.EVB_REQUEST_FAILED]: 'Failed to request eVB',
  [VGL_ERROR_CODE.EVB_PRINT_SUBMIT_MISSING_VN]:
    'No VN loaded - cant submit eVB Print handler',
  [VGL_ERROR_CODE.EVB_SOFTFAIR_DISTRIBUTION_TRANSMISSION_FAILED]:
    'No distribution information submitted - cant submit eVB Print handler',
  [VGL_ERROR_CODE.EVB_INSURANCE_ID_LOOKUP_FAILED]:
    'Could not find insurance ID for eVB distribution',

  [VGL_ERROR_CODE.TYPE_AHEAD_LOADING_FAILED]: 'Could not load typeAhead',

  [VGL_ERROR_CODE.WKZ_SELECTION_FAILED]: 'Could not determine target Sparte',

  [VGL_ERROR_CODE.LOCAL_STORAGE_TRANSFER_FAILED]:
    'Could not load transferred input data',

  [VGL_ERROR_CODE.KFZ_SETUP]: 'KFZ Setup failed due to missing data',

  [VGL_ERROR_CODE.INPUT_MAPPING_LOADING_FAILED]: 'Failed to load input mapping',
  [VGL_ERROR_CODE.INPUT_MAPPING_CONFIG_MISSING]: 'Missing input mapping config',
  [VGL_ERROR_CODE.INPUT_MAPPING_MISSING_VN]:
    'Missing versicherungsnehmer in clientFields sparten config',
  [VGL_ERROR_CODE.INPUT_MAPPING_UNKNOWN_PATH_SOURCE_LOOKUP]:
    'Path could not be found looking for source',

  [VGL_ERROR_CODE.PKV_PREVIOUS_INSURANCE_LOADING_FAILED]:
    'Failed to load previous insurance products',

  [VGL_ERROR_CODE.VEHICLE_DATA_LOOKUP_FAILED]: 'Failed to lookup vehicle data',

  [VGL_ERROR_CODE.COMPLEX_SELECT_COMPANY_LOADING_FAILED]:
    'Failed to load companies for complex select',
  [VGL_ERROR_CODE.COMPLEX_SELECT_VALUES_LOADING_FAILED]:
    'Failed to load values for complex select',

  [VGL_ERROR_CODE.ENTITY_MANAGER_MISSING_STORE_FUNCTION]:
    'Missing entity manager store function',

  [VGL_ERROR_CODE.AI_DOCUMENT_UPLOAD_FAILED]: 'Failed to upload document',

  [VGL_ERROR_CODE.VA_LOADING_FAILED]: 'Failed to load versicherungsangaben',
  [VGL_ERROR_CODE.VA_STORING_FAILED]: 'Failed to store versicherungsangaben',
  [VGL_ERROR_CODE.VA_CLOSE_FAILED]: 'Failed to close versicherungsangaben',
  [VGL_ERROR_CODE.VA_UPDATE_FAILED]: 'Failed to update versicherungsangaben',
};

export const VglUserErrorMessages: VGLUserErrorMessages = {
  [VGL_ERROR_CODE.GENERAL_UNHANDLED_START_CALCULATION_ERROR]:
    'Bei der Ausführung der Validierung ist es zu einem Fehler gekommen. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.BROKER_SAVING_SETTINGS_FAILED]:
    'Beim Speichern der Einstellungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.BROKER_ID_NOT_SET]:
    'Beim Abrufen der Makler ID ist es zu einem Fehler gekommen. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.CHOICES_SIMPLE_LOADING_FAILED]:
    'Beim Laden der Select-Optionen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.COMPANIES_LOADING_FAILED]:
    'Beim Laden der Gesellschaften ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.COMPANIES_SPECIAL_LOADING_FAILED]:
    'Beim Laden der Krankenkassen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.FEATURES_LOADING_FAILED]:
    'Beim Laden der Merkmale ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.FEATURES_TARIFF_LOADING_FAILED]:
    'Beim Laden der Tarifmerkmale ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.GLOBAL_LOADING_FAILED]:
    'Beim Laden der Sparte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.GLOBAL_INITIALIZATION_FAILED]:
    'Beim Laden der Sparte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.MAIL_TEMPLATES_LOADING_FAILED]:
    'Beim Laden der Mail-Templates ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_LOADING_DEFAULT_FAILED]:
    'Beim Laden des Standard Mail-Templates ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_LOADING_PLACEHOLDERS_FAILED]:
    'Beim Laden der Mail-Template Platzhalter ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_GENERATE_PREVIEW_FAILED]:
    'Beim Erstellen der Mail-Vorschau ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_STORING_FAILED]:
    'Beim Speicher des Mail-Templates ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_UPDATING_FAILED]:
    'Beim Aktualisieren des Mail-Templates ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.MAIL_TEMPLATES_DELETING_FAILED]:
    'Beim Löschen des Mail-Templates ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.PROFILE_LOADING_FAILED]:
    'Beim Laden der Profile ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.PROFILE_STORING_FAILED]:
    'Beim Erstellen des Profils ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.PROFILE_UPDATING_FAILED]:
    'Beim Aktualisieren des Profils ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.PROFILE_DELETING_FAILED]:
    'Beim Löschen des Profils ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.PROFILE_LOADING_SELECTED_FAILED]:
    'Beim Laden des aktiven Profils ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.PROFILE_NOT_FOUND]:
    'Beim Laden des Profils ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.QUOTE_LOADING_FAILED]:
    'Dieses Angebot konnte leider nicht geladen werden. Wenn wir das Problem für Sie untersuchen sollen, kontaktieren Sie uns bitte über beratungsvorsprung@demv.de',
  [VGL_ERROR_CODE.QUOTE_STORING_FAILED]:
    'Beim Erstellen des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.QUOTE_TRANSFORMATION_FAILED]:
    'Beim Laden des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.QUOTE_WEBREPORT_LOADING_FAILED]:
    'Beim Laden des Webreports ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.QUOTE_INVENTORY_CONTRACT_LOADING_FAILED]:
    'Dieser Bestandsvertrag konnte leider nicht geladen werden. Wenn wir das Problem für Sie untersuchen sollen, kontaktieren Sie uns bitte über beratungsvorsprung@demv.de',
  [VGL_ERROR_CODE.QUOTE_WEBREPORT_NOT_FOUND]:
    'Der Weblink ist abgelaufen. Bitte kontaktieren Sie Ihren Berater um einen neuen Link zu erhalten.',

  [VGL_ERROR_CODE.TARIFFS_LOADING_FAILED]:
    'Beim Laden der Tarife ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.TARIFFS_CONTRACT_TARIFF_NOT_FOUND]:
    'Es wurde kein Tarif für den Antrag gefunden. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.TARIFFS_LOADING_SPECIAL_FAILED]:
    'Beim Laden der Tarife ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.UTIL_CREATE_VALIDATE_STATE_FAILED]:
    'Beim Erstellen der Regeln für die Validierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.DISTRIBUTION_LOADING_FAILED]:
    'Beim Laden der Vertriebsweginformationen ist ein Fehler aufgetreten. Bitte Versuchen Sie es erneut.',
  [VGL_ERROR_CODE.DISTRIBUTION_NO_VALID_TARIFF_RECOMMENDED]:
    'Es ist kein valider Tariff ausgewählt. Bitte Versuchen Sie es erneut.',
  [VGL_ERROR_CODE.DISTRIBUTION_SAVING_FAILED]:
    'Beim Speichern der Vertriebsweginformationen ist ein Fehler aufgetreten. Bitte Versuchen Sie es erneut.',
  [VGL_ERROR_CODE.DISTRIBUTION_SELECTED_POOL_NOT_FOUND]:
    'Der ausgewählte Pool wurde nicht gefunden. Bitte Versuchen Sie es erneut.',

  [VGL_ERROR_CODE.FILES_LOADING_FAILED]:
    'Beim Laden der Antragsdokumente ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.CONTRACT_NO_RESPONSE_DATA]:
    'Beim Erstellen des Antrags ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.CONTRACT_GENERATE_FAILED]:
    'Beim Erstellen des Antrags ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.COMPANY_QUESTION_MISSING_VALIDATION_DEFINITION]:
    'Es gibt ein Problem mit den Gesellschaftsfragen. Wir kümmern uns umgehend um diese Problematik.',
  [VGL_ERROR_CODE.COMPANY_QUESTION_FAILED_TO_LOAD_QUESTIONS]:
    'Beim Laden der Gesellschaftsfragen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.COMPANY_QUESTION_ACCESSING_INVALID_ID]:
    'Beim Laden der Gesellschaftsfragen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.EVB_LOADING_FAILED]:
    'Die Daten für die eVB Generierung konnten nicht abgefragt werden. Bitte versuchen Sie es später erneut.',

  [VGL_ERROR_CODE.WKZ_SELECTION_FAILED]:
    'Bei der Auswahl des Ziel-Rechners ist es leider zu einem Problem gekommen. Bitte öffnen Sie den Vergleichsrechner manuell',

  [VGL_ERROR_CODE.LOCAL_STORAGE_TRANSFER_FAILED]:
    'Die Datenübernahme aus dem vorherigen Rechner ist fehlgeschlagen. Bitte prüfen Sie dass die Eingaben keine Fehler enthalten.',

  [VGL_ERROR_CODE.INPUT_MAPPING_LOADING_FAILED]:
    'Beim Laden der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  [VGL_ERROR_CODE.INPUT_MAPPING_UNKNOWN_PATH_SOURCE_LOOKUP]:
    'Beim Laden der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.PKV_PREVIOUS_INSURANCE_LOADING_FAILED]:
    'Die Tarifbausteine konnten nicht geladen werden. Bitte versuchen Sie es erneut.',

  [VGL_ERROR_CODE.VA_LOADING_FAILED]:
    'Die Versicherungsangaben konnten nicht geladen werden. Bitte kontaktieren Sie Ihren Berater um einen neuen Link zu erhalten.',
  [VGL_ERROR_CODE.VA_STORING_FAILED]:
    'Die Versicherungsangaben konnten nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
  [VGL_ERROR_CODE.VA_CLOSE_FAILED]:
    'Die Versicherungsangaben konnte nicht abgeschlossen werden. Bitte kontaktieren Sie Ihren Berater.',
  [VGL_ERROR_CODE.VA_UPDATE_FAILED]:
    'Die Versicherungsangaben konnten nicht aktualisiert werden. Bitte kontaktieren Sie Ihren Berater.',
};
